import { HostBinding, Input, Directive } from '@angular/core';

@Directive()
export class LMStyleDirectiveBase {

  private style: LMFieldStyle;
  protected _isTag: boolean;

  constructor() {}

  @Input() set isTag(isTag: boolean) {
    this._isTag = isTag;
  }

  public setStyle(style: LMFieldStyle) {
    this.style = style;
  }

  @HostBinding('class.lm-font-xl') get header1() {
    return this.style ? this.style.header === 1 : false;
  }
  @HostBinding('class.lm-font-lg') get header2() {
    return this.style ? this.style.header === 2 : false;
  }
  @HostBinding('class.lm-font-md') get header3() {
    return this.style ? this.style.header === 3 : false;
  }
  @HostBinding('class.lm-font-sm') get header4() {
    return this.style ? this.style.header === 4 : false;
  }
  @HostBinding('class.lm-font-xs') get header5() {
    return this.style ? this.style.header === 5 : false;
  }

  @HostBinding('class.lpl-black') get black() {
    // Need black font on yellow tags for accessibility
    if (this._isTag && this?.style?.color === 'yellow') {
      return true;
    }

    return this.style && !this._isTag ? this.style.color === 'black' : false;
  }
  @HostBinding('class.lpl-blue') get blue() {
    return this.style && !this._isTag ? this.style.color === 'blue' : false;
  }
  @HostBinding('class.lpl-brown') get brown() {
    return this.style && !this._isTag ? this.style.color === 'brown' : false;
  }
  @HostBinding('class.lpl-gray') get gray() {
    return this.style && !this._isTag ? this.style.color === 'gray' : false;
  }
  @HostBinding('class.lpl-green') get green() {
    return this.style && !this._isTag ? this.style.color === 'green' || this.style.color === 'jade' : false;
  }
  @HostBinding('class.lpl-orange') get orange() {
    return this.style && !this._isTag ? this.style.color === 'orange' : false;
  }
  @HostBinding('class.lpl-purple') get purple() {
    return this.style && !this._isTag ? this.style.color === 'purple' || this.style.color === 'magenta' : false;
  }
  @HostBinding('class.lpl-red') get red() {
    return this.style && !this._isTag ? this.style.color === 'red' || this.style.color === 'maroon' : false
  }
  @HostBinding('class.lpl-turquoise') get turquoise() {
    return this.style && !this._isTag ? this.style.color === 'turquoise' : false;
  }
  @HostBinding('class.lpl-yellow') get yellow() {
    return this.style && !this._isTag ? this.style.color === 'yellow' : false;
  }

  // background color bindings for isTag
  @HostBinding('class.lpl-black-bg') get bgBlack() {
    return this.style && this._isTag ? this.style.color === 'black' : false;
  }
  @HostBinding('class.lpl-blue-bg') get bgBlue() {
    return this.style && this._isTag ? this.style.color === 'blue' : false;
  }
  @HostBinding('class.lpl-brown-bg') get bgBrown() {
    return this.style && this._isTag ? this.style.color === 'brown' : false;
  }
  @HostBinding('class.lpl-gray-bg') get bgGray() {
    return this.style && this._isTag ? this.style.color === 'gray' : false;
  }
  @HostBinding('class.lpl-green-bg') get bgGreen() {
    return this.style && this._isTag ? this.style.color === 'green' || this.style.color === 'jade' : false;
  }
  @HostBinding('class.lpl-orange-bg') get bgOrange() {
    return this.style && this._isTag ? this.style.color === 'orange' : false;
  }
  @HostBinding('class.lpl-purple-bg') get bgPurple() {
    return this.style && this._isTag ? this.style.color === 'purple' || this.style.color === 'magenta' : false;
  }
  @HostBinding('class.lpl-red-bg') get bgRed() {
    return this.style && this._isTag ? this.style.color === 'red' || this.style.color === 'maroon' : false
  }
  @HostBinding('class.lpl-turquoise-bg') get bgTurquoise() {
    return this.style && this._isTag ? this.style.color === 'turquoise' : false;
  }
  @HostBinding('class.lpl-yellow-bg') get bgYellow() {
    return this.style && this._isTag ? this.style.color === 'yellow' : false;
  }

  @HostBinding('class.text-strong') get isBold() {
    return this.style ? this.style.bold : false;
  };
  @HostBinding('class.text-emphasis') get isItalic() {
    return this.style ? this.style.italics : false;
  };

  @HostBinding('style.text-align') get textAlign() {
    return this.style && this.style.align ? this.style.align : null;
  }
}
